enum AuthenticationSource {
  FINNISH = 'SUOMALAINEN',
  EIDAS = 'EIDAS',
  VIRKAILIJA = 'VIRKAILIJA',
}

export default AuthenticationSource
